module.exports = __webpack_public_path__ + "static/approver-dashboard-73cac6949a5a04a49e58e911b924a5dd.png";